import React from "react";
import AppContext from "@/js/common/AppContext";
import Axios from "@/js/common/Axios";
import Util from "@/js/common/Util";
import Button from "@/js/common/ui/Button";
import SelectBox from "@/js/common/ui/input/SelectBox";
import DatePickerBox from "@/js/common/ui/input/DatePickerBox";
import TextBox from "@/js/common/ui/input/TextBox";
import NumberTextBox from "@/js/common/ui/input/NumberTextBox";
import Modal from "@/js/common/ui/modal/Modal";
import DialogTitleBar from "@/js/system/common/DialogTitleBar";
import BudgetViewFile from "../../budgetFileBox/BudgetViewFile";
import { budgetFilesProps } from "@/js/common/types/types";
import BgtAtrzRejectReason from "./BgtAtrzRejectReason";

interface Props {
  ovrlMbsdsDpstDocId: string;
  atrzId: string;
  atrzLineId: string;
  setCallTime: Function;
  onDone?: () => void;
}

const BgtAtrzRtsoOvrlDpstDialog = ({
  ovrlMbsdsDpstDocId,
  atrzId,
  atrzLineId,
  setCallTime,
  onDone,
}: Props) => {
  const [dpstRsdocNo, setDpstRsdocNo] = React.useState<string>("");
  const [orgCd, setOrgCd] = React.useState<string>("");
  const [dpstDt, setDpstDt] = React.useState<string>("");
  const [bgtSbjct1stCd, setBgtSbjct1stCd] = React.useState<string>("");
  const [bgtSbjct2stCd, setBgtSbjct2stCd] = React.useState<string>("");
  const [bgtSbjct3stCd, setBgtSbjct3stCd] = React.useState<string>("");
  const [abstrCn, setAbstrCn] = React.useState<string>("");
  const [memo, setMemo] = React.useState<string>("");
  const [dpstAmt, setDpstAmt] = React.useState<string>("");
  const [atrzSttsCd, setAtrzSttsCd] = React.useState<string>("");
  const [atrzOpnnCn, setAtrzOpnnCn] = React.useState<string>("");
  const [savedDpstFiles, setSavedDpstFiles] = React.useState<budgetFilesProps[]>([]);
  const [confirming, setConfirming] = React.useState(false);
  const [rejectModalOpen, setRejectModalOpen] = React.useState(false);

  const clearForm = () => {
    setDpstRsdocNo("");
    setOrgCd("");
    setDpstDt("");
    setBgtSbjct1stCd("");
    setBgtSbjct2stCd("");
    setBgtSbjct3stCd("");
    setAbstrCn("");
    setMemo("");
    setDpstAmt("");
    setAtrzSttsCd("");
    setAtrzOpnnCn("");
    setSavedDpstFiles([]);
  };

  const loadDetail = (linkDocId: string) => {
    if (Util.isEmpty(linkDocId)) {
      clearForm();
      return;
    }

    AppContext.showSpinner();
    Axios.dataAccess({
      url: "system/atrz/ovrl/select-aprvr-ovrl-dpst-dtl.do",
      methodType: "post",
      paramType: "json",
      paramData: {
        atrzId,
        atrzLineId,
        atrzLinkDocId: linkDocId,
      },
      onSuccessFn: (res: any) => {
        const item = res?.result?.item || {};

        setDpstRsdocNo(String(item.dpstRsdocNo || ""));
        setOrgCd(String(item.orgCd || ""));
        setDpstDt(Util.cvtDateStrForm(item.dpstDt, "-", "YYYYMMDD"));
        setBgtSbjct1stCd(String(item.bgtSbjct1stCd || ""));
        setBgtSbjct2stCd(String(item.bgtSbjct2stCd || ""));
        setBgtSbjct3stCd(String(item.bgtSbjct3stCd || ""));
        setAbstrCn(String(item.abstrCn || ""));
        setMemo(String(item.memo || ""));
        setDpstAmt(Util.comma(item.dpstAmt));
        setAtrzOpnnCn(String(item.atrzOpnnCn || ""));
        setAtrzSttsCd(String(item.atrzSttsCd || ""));

        const files = res?.result?.listFile || res?.result?.files || [];
        setSavedDpstFiles(files);

        AppContext.hideSpinner();
      },
    });
  };

  React.useEffect(() => {
    loadDetail(ovrlMbsdsDpstDocId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ovrlMbsdsDpstDocId]);

  const validateBase = () => {
    if (Util.isEmpty(atrzId)) {
      AppContext.openAlert({ title: "알림", msg: "결재 정보(atrzId)가 없습니다.", icon: "warning" });
      return false;
    }
    if (Util.isEmpty(atrzLineId)) {
      AppContext.openAlert({ title: "알림", msg: "결재 정보(atrzLineId)가 없습니다.", icon: "warning" });
      return false;
    }
    if (Util.isEmpty(ovrlMbsdsDpstDocId)) {
      AppContext.openAlert({ title: "알림", msg: "대상이 선택되지 않았습니다.", icon: "warning" });
      return false;
    }
    return true;
  };

  const handleConfirm = () => {
    if (confirming) return;
    if (!validateBase()) return;

    setConfirming(true);
    AppContext.showSpinner();

    Axios.dataAccess({
      url: "system/atrz/process-aprvr-idnty-rjct.do",
      methodType: "post",
      paramType: "json",
      paramData: {
        atrzId: String(atrzId),
        atrzLineId: String(atrzLineId),
        atrzLinkDocId: String(ovrlMbsdsDpstDocId),
        atrzLinkDocIdntySeCd: "01",
      },
      onSuccessFn: () => {
        AppContext.hideSpinner();
        setConfirming(false);
        AppContext.openAlert({ title: "알림", msg: "확인 처리되었습니다.", icon: "info" });
        if (typeof setCallTime === "function") setCallTime(new Date());
        onDone?.();
      },
    });
  };

  const openReject = () => {
    if (!validateBase()) return;
    setRejectModalOpen(true);
  };

  return (
    <div className="w100p dpFlx jcC pt5">
      <div className="dpFlx aiFs jcSb">
        <div className="w400">
          <div>
              <span className="fm-b fs16 fc007bff ls1 fw700">수입결의서 상세내용</span>
              <span className="fm-b fs13 ls06 fc777777" style={{marginLeft: "110px"}}>{dpstRsdocNo}</span>
          </div>
          <div className="dpFlx mb5 pt10" style={{ width: 400, gap: 8 }}>
            <div className="dpFlx flxdCol" style={{ width: 196 }}>
              <div className="h30 dpFlx aiE pb5">
                <span className="fm-b fs13 ls06 fc111111">수입일자</span>
              </div>
              <DatePickerBox
                value={dpstDt}
                width={196}
                height={36}
                fontSize={14}
                fontFamily="fm-c"
                color="#333"
                letterSpacing={-1}
                borderColor="#ddd"
                borderOnColor="#222"
                borderRadius={2}
                bgColor="#F6F6F6"
                textAlign="left"
                calendarThemeColor={AppContext.themeColor}
                onChange={(data: string) => setDpstDt(data)}
                disabled={true}
              />
            </div>

            <div className="dpFlx flxdCol" style={{ width: 196 }}>
              <div className="h30 dpFlx aiE pb5">
                <span className="fm-b fs13 ls06 fc111111">금액</span>
              </div>
              <div className="h36 dpFlx aiC bsBdb" style={{ width: 196 }}>
                <NumberTextBox
                  value={dpstAmt}
                  onChange={(data: string) => setDpstAmt(data)}
                  className="h36 bd1 bdrd2 bgcFFE6CE"
                  style={{ width: 196 }}
                  thousandsGroupStyle="thousand"
                  thousandSeparator=","
                  placeholder="0"
                  fontSize={14}
                  fontFamily="fm-c"
                  letterSpacing={-1}
                  inputClass="taR mr5"
                  disabled={true}
                />
              </div>
            </div>
          </div>

          <div className="dpFlx mb5" style={{ width: 400, gap: 8 }}>
            <div className="dpFlx flxdCol" style={{ width: 128 }}>
              <div className="h30 dpFlx aiE pb5">
                <span className="fm-b fs13 ls06 fc111111">관</span>
              </div>
              <SelectBox
                value={bgtSbjct1stCd}
                width={128}
                height={36}
                fontSize={14}
                fontFamily="fm-c"
                color="#333"
                letterSpacing={-1}
                borderColor="#ddd"
                borderOnColor="#222"
                borderRadius={2}
                background="#F6F6F6"
                paddingRight={8}
                codeArray={[{ code: "", name: "선택" }].concat(Util.getBgt1CodeArray("01", orgCd))}
                onChangeFunc={(data: string) => {
                  setBgtSbjct1stCd(data);
                  setBgtSbjct2stCd("");
                  setBgtSbjct3stCd("");
                }}
                disabled={true}
              />
            </div>

            <div className="dpFlx flxdCol" style={{ width: 128 }}>
              <div className="h30 dpFlx aiE pb5">
                <span className="fm-b fs13 ls06 fc111111">항</span>
              </div>
              <SelectBox
                value={bgtSbjct2stCd}
                width={128}
                height={36}
                fontSize={14}
                fontFamily="fm-c"
                color="#333"
                letterSpacing={-1}
                borderColor="#ddd"
                borderOnColor="#222"
                borderRadius={2}
                background="#F6F6F6"
                paddingRight={8}
                codeArray={[{ code: "", name: "선택" }].concat(Util.getBgt2CodeArray(bgtSbjct1stCd, orgCd))}
                onChangeFunc={(data: string) => {
                  setBgtSbjct2stCd(data);
                  setBgtSbjct3stCd("");
                }}
                disabled={true}
              />
            </div>

            <div className="dpFlx flxdCol" style={{ width: 128 }}>
              <div className="h30 dpFlx aiE pb5">
                <span className="fm-b fs13 ls06 fc111111">목</span>
              </div>
              <SelectBox
                value={bgtSbjct3stCd}
                width={128}
                height={36}
                fontSize={14}
                fontFamily="fm-c"
                color="#333"
                letterSpacing={-1}
                borderColor="#ddd"
                borderOnColor="#222"
                borderRadius={2}
                background="#F6F6F6"
                paddingRight={8}
                codeArray={[{ code: "", name: "선택" }].concat(Util.getBgt3CodeArray(bgtSbjct2stCd, orgCd))}
                onChangeFunc={(data: string) => setBgtSbjct3stCd(data)}
                disabled={true}
              />
            </div>
          </div>

          <div className="dpFlx flxdCol mb5" style={{ width: 400 }}>
            <div className="h30 dpFlx aiE pb5">
              <span className="fm-b fs13 ls06 fc111111">적요</span>
            </div>
            <TextBox
              value={abstrCn}
              width={400}
              height={36}
              fontSize={14}
              fontFamily="fm-c"
              color="#333"
              letterSpacing={-1}
              borderColor="#ddd"
              borderOnColor="#222"
              borderRadius={2}
              style={{ backgroundColor: "#F6F6F6", padding: "0 12px" }}
              onChangeFunc={(t: string) => setAbstrCn(t)}
              mode="disabled"
            />
          </div>

          <div className="dpFlx flxdCol mb5" style={{ width: 400 }}>
            <div className="h30 dpFlx aiE pb5">
              <span className="fm-b fs13 ls06 fc111111">메모</span>
            </div>
            <TextBox
              value={memo}
              width={400}
              height={36}
              fontSize={14}
              fontFamily="fm-c"
              color="#333"
              letterSpacing={-1}
              borderColor="#ddd"
              borderOnColor="#222"
              borderRadius={2}
              style={{ backgroundColor: "#F6F6F6", padding: "0 12px" }}
              onChangeFunc={(t: string) => setMemo(t)}
              mode="disabled"
            />
          </div>

          <BudgetViewFile fileSeCd="C01" savedBudgetFiles={savedDpstFiles} width="400px" height="70px" />

          {atrzSttsCd === "05" && (
            <div className="dpFlx flxdCol" style={{ width: 400 }}>
              <div className="h30 dpFlx aiE pb5">
                <span className="fm-b fs13 ls06 fc111111">반려</span>
              </div>
              <div className="dpFlx aiFs">
                <div className="flxg1 bsBdb">
                  <textarea
                    value={atrzOpnnCn}
                    className="h70 bsBdb p10 bd1 bdcDFDFDF bdrd2 fm-c fs13 fc333333 ls1 bgcF6F6F6 rszN"
                    style={{ width: "400px" }}
                    maxLength={2000}
                    placeholder=""
                    onChange={(e) => setAtrzOpnnCn(e.target.value)}
                    readOnly={true}
                  />
                </div>
              </div>
            </div>
          )}

          <div className="dpFlx jcR mt25 gap10" style={{ width: 400 }}>
            <Button
              width={100}
              height={40}
              fontFamily="fm-b"
              fontSize={16}
              letterSpacing={-1}
              color="#fff"
              backgroundColor="crimson"
              borderRadius={6}
              buttonClass="dpFlx aiC jcC"
              buttonName="반려"
              onClickFunc={openReject}
              disabled={confirming}
            />
            <Button
              width={100}
              height={40}
              fontFamily="fm-b"
              fontSize={16}
              letterSpacing={-1}
              color="#fff"
              backgroundColor="#007bff"
              borderRadius={6}
              buttonClass="dpFlx aiC jcC"
              buttonName={confirming ? "처리중..." : "확인"}
              onClickFunc={handleConfirm}
              disabled={confirming}
            />
          </div>

          <Modal
            modalOpen={rejectModalOpen}
            dim={true}
            visible={true}
            titleEl={<DialogTitleBar title="반려 사유 입력" backgroundColor={AppContext.themeColor} />}
            onCloseFunc={() => setRejectModalOpen(false)}
          >
            <BgtAtrzRejectReason
              atrzId={String(atrzId)}
              atrzLineId={String(atrzLineId)}
              atrzLinkDocId={String(ovrlMbsdsDpstDocId)}
              setModalOpen={setRejectModalOpen}
              setCallTime={setCallTime}
              onDone={onDone}
            />
          </Modal>
        </div>
      </div>
    </div>
  );
};

export default BgtAtrzRtsoOvrlDpstDialog;
